import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ROLES = [
  { v: "epc", label: "Installer / EPC" },
  { v: "investor", label: "Investor" },
  { v: "manager", label: "Project Manager" },
  { v: "customer", label: "Customer" },
];

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "epc", org: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const r = await register(form);
    setBusy(false);
    if (r.ok) nav("/", { replace: true }); else setErr(r.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="register-page">
      <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
        <div className="label mb-3">Create account</div>
        <h1 className="font-display text-4xl font-bold mb-8">Join FLOW Energy App.</h1>
        <div className="space-y-5">
          <div>
            <label className="label block mb-1">Full name</label>
            <input data-testid="register-name-input" className="input-swiss" value={form.name} onChange={upd("name")} required />
          </div>
          <div>
            <label className="label block mb-1">Email</label>
            <input data-testid="register-email-input" className="input-swiss" type="email" value={form.email} onChange={upd("email")} required />
          </div>
          <div>
            <label className="label block mb-1">Password</label>
            <input data-testid="register-password-input" className="input-swiss" type="password" minLength={6} value={form.password} onChange={upd("password")} required />
          </div>
          <div>
            <label className="label block mb-1">Role</label>
            <select data-testid="register-role-select" className="input-box" value={form.role} onChange={upd("role")}>
              {ROLES.map(r => <option key={r.v} value={r.v}>{r.label}</option>)}
            </select>
          </div>
          <div>
            <label className="label block mb-1">Company / Organisation</label>
            <input data-testid="register-org-input" className="input-swiss" value={form.org} onChange={upd("org")} />
          </div>
          {err && <div className="text-xs text-[var(--err)] font-mono">{err}</div>}
          <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="register-submit-btn">
            {busy ? "Creating…" : "Create account"}
          </button>
          <div className="text-xs muted">
            Already registered? <Link to="/login" className="text-[var(--ink)] underline" data-testid="login-link">Sign in</Link>
          </div>
        </div>
      </form>
    </div>
  );
}
